var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPracticeProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 20.5V9.5H3C2.72386 9.5 2.5 9.72386 2.5 10V20.5H5ZM5 4V8H3C1.89543 8 1 8.89543 1 10V22H5H19H23V10C23 8.89543 22.1046 8 21 8H19V4C19 2.89543 18.1046 2 17 2H7C5.89543 2 5 2.89543 5 4ZM21.5 20.5H19V9.5H21C21.2761 9.5 21.5 9.72386 21.5 10V20.5ZM7 3.5H17C17.2761 3.5 17.5 3.72386 17.5 4V20.5H15V17H9V20.5H6.5V4C6.5 3.72386 6.72386 3.5 7 3.5ZM10.5 20.5H13.5V18.5H10.5V20.5ZM12.75 4.25H11.25V6L9.5 6V7.5H11.25V9.25H12.75V7.5H14.5V6H12.75V4.25ZM9.75 11H8.25V12.5H9.75V11ZM12.75 11H11.25V12.5H12.75V11ZM14.25 11H15.75V12.5H14.25V11ZM15.75 14H14.25V15.5H15.75V14ZM11.25 14H12.75V15.5H11.25V14ZM9.75 14H8.25V15.5H9.75V14Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticeProfile);
export default __webpack_public_path__ + "static/media/practice-profile.77653752ea4ca97aae7b4e104c402a35.svg";
export { ForwardRef as ReactComponent };